export interface ImageMapperShowcaseItem {
  x: number;
  y: number;
  name: string;
  id: number;
  color?: string;
}
